import React from 'react'
import { browserHistory } from 'react-router'
import common from '../Common/Common.scss'
import Leaderboards from './Leaderboards'

class LeaderboardList extends React.Component {

  constructor (props) {
    super(props)

    const self: any = this
    self.state = { type: 'daily' }
    self.setType = self.setType.bind(self)
  }

  componentWillMount () {
    window.scrollTo(0, 0)
  }

  setType (type) {
    const { toggleSidebar } = this.props

    toggleSidebar(false)
    this.setState({ type })
  }

  render () {
    const { baseUrl } = this.props
    const { type } = this.state

    return (
      <div className={common.gameList}>
        <ul className={common.gameTabs}>
          <li onClick={() => this.setType('daily')} className={type === 'daily' && common.active}>Daily</li>
          <li onClick={() => this.setType('weekly')} className={type === 'weekly' && common.active}>Weekly</li>
          <li onClick={() => this.setType('alltime')} className={type === 'alltime' && common.active}>All-Time</li>
        </ul>
        {type === 'daily' && <Leaderboards type='daily' baseUrl={baseUrl} />}
        {type === 'weekly' && <Leaderboards type='weekly' baseUrl={baseUrl} />}
        {type === 'alltime' && <Leaderboards type='alltime' baseUrl={baseUrl} />}
      </div>
    )
  }
}

export default LeaderboardList



/** WEBPACK FOOTER **
 ** ./src/components/Leaderboards/LeaderboardsList.js
 **/